// Generated by ReScript, PLEASE EDIT WITH CARE


function paymentMode(str) {
  switch (str) {
    case "ach_debit" :
        return "ACHBankDebit";
    case "ach_transfer" :
        return "ACHTransfer";
    case "affirm" :
        return "Affirm";
    case "afterpay_clearpay" :
        return "AfterPay";
    case "apple_pay" :
        return "ApplePay";
    case "bacs_debit" :
        return "BacsBankDebit";
    case "bacs_transfer" :
        return "BacsTransfer";
    case "bancontact_card" :
        return "BanContactCard";
    case "becs_debit" :
        return "BecsBankDebit";
    case "boleto" :
        return "Boleto";
    case "card" :
        return "Card";
    case "crypto_currency" :
        return "CryptoCurrency";
    case "eft" :
        return "EFT";
    case "eps" :
        return "EPS";
    case "giropay" :
        return "GiroPay";
    case "givex" :
        return "Givex";
    case "google_pay" :
        return "GooglePay";
    case "ideal" :
        return "Ideal";
    case "instant_bank_transfer" :
        return "InstantTransfer";
    case "instant_bank_transfer_finland" :
        return "InstantTransferFinland";
    case "instant_bank_transfer_poland" :
        return "InstantTransferPoland";
    case "klarna" :
        return "Klarna";
    case "paypal" :
        return "PayPal";
    case "revolut_pay" :
        return "RevolutPay";
    case "samsung_pay" :
        return "SamsungPay";
    case "saved_methods" :
        return "SavedMethods";
    case "sepa_bank_transfer" :
        return "SepaTransfer";
    case "sepa_debit" :
        return "SepaBankDebit";
    case "sofort" :
        return "Sofort";
    default:
      return "Unknown";
  }
}

var defaultOrder = [
  "saved_methods",
  "card",
  "apple_pay",
  "google_pay",
  "paypal",
  "klarna",
  "samsung_pay",
  "affirm",
  "afterpay_clearpay",
  "ach_transfer",
  "sepa_bank_transfer",
  "instant_bank_transfer",
  "instant_bank_transfer_finland",
  "instant_bank_transfer_poland",
  "bacs_transfer",
  "ach_debit",
  "sepa_debit",
  "bacs_debit",
  "becs_debit",
  "sofort",
  "giropay",
  "ideal",
  "eps",
  "crypto",
  "bancontact_card",
  "boleto",
  "eft",
  "revolut_pay",
  "givex"
];

export {
  paymentMode ,
  defaultOrder ,
}
/* No side effect */
